import { Alert, AlertTitle, Grid, Typography } from '@mui/material';
import { useGeoEventGeolocationFormFieldChanges } from 'features/geoEvents/hooks/useGeoEventGeolocationFormFieldChanges';
import { Wildfire } from 'features/wildfires/wildfire.types';
import { useTranslation } from 'react-i18next';

type EditAutomatedGeoEventChangelogProps = {
  geoEvent: Wildfire;
};

/**
 * Pre-submit preview of the geolocation changes, matching `WildfireChangelog`'s
 * look. Only the geolocation group applies here: this form can't edit the
 * fields the other changelog hooks read.
 */
export const EditAutomatedGeoEventChangelog = (
  props: EditAutomatedGeoEventChangelogProps,
): JSX.Element | null => {
  const { geoEvent } = props;
  const { t } = useTranslation();

  const locationChanges = useGeoEventGeolocationFormFieldChanges({ geoEvent });
  const changes = Object.values(locationChanges).filter(Boolean);

  if (!changes.length) return null;

  return (
    <Grid size={12}>
      <Alert severity="warning" data-testid="changelog-alert">
        <AlertTitle>{t('geoEventChangelog.title')}</AlertTitle>
        {changes.map((change) => (
          <Typography key={change}>{change}</Typography>
        ))}
      </Alert>
    </Grid>
  );
};
